/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import firebase from 'firebase/compat/app';
import { collection, doc, getDocs, orderBy, query } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Arrow from '../asset/leadingArrow.png';
import { db } from '../config/firebaseConfig';
import { UserAuth } from '../context/authContext';

const JoinedRoom = () => {
  const { userData, user } = UserAuth();
  const [roomId, setRoomId] = useState(localStorage.getItem('roomId') || '');
  const [datax, setDatax] = useState('');

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe = db
      .collection('rooms')
      .doc(roomId)
      .onSnapshot(
        (roomSnapshot) => {
          if (roomSnapshot.exists) {
            const data = roomSnapshot.data();
            setDatax(data);
            setCreatedBy(data.createdBy || []);
          } else {
            localStorage.removeItem('roomId');
            window.location.reload();
          }
        },
        (error) => {
          toast.error('Error fetching room details.');
        }
      );

    return () => unsubscribe();
  }, [roomId]);

  const [role, setRole] = useState(() => localStorage.getItem('role') || '');
  const [participants, setParticipants] = useState([]);
  // const roomData = db.collection("rooms").doc(roomId).get();
  const [createdBy, setCreatedBy] = useState([]);

  const handleLeaveRoom = async () => {
    try {
      await db
        .collection('rooms')
        .doc(roomId)
        .update({
          [`${role}s`]: firebase.firestore.FieldValue.arrayRemove(
            userData.publicKey
          ),
        });
      localStorage.removeItem('roomId');
      localStorage.removeItem('role');
      toast.success('You have left the room successfully.');
      window.location.href = '/';
      setRoomId('');
      setRole('');
    } catch (error) {
      console.error('Error leaving room:', error);
      toast.error('Failed to leave room. Please try again later.');
    }
  };

  const handleEndRoom = async () => {
    if (roomId && user.email) {
      try {
        const roomDocRef = db.collection('rooms').doc(roomId);

        const subcollectionNames = ['blocks', 'transactions'];

        await Promise.all(
          subcollectionNames.map(async (subcollectionName) => {
            const subcollectionRef = roomDocRef.collection(subcollectionName);
            const docs = await subcollectionRef.get();
            docs.forEach(async (doc) => {
              await doc.ref.delete();
            });
          })
        );

        await roomDocRef.delete();

        toast.success('Room ended successfully.');
        window.location.href = '/';

        setRoomId('');
        setParticipants([]);
        localStorage.removeItem('roomId');
      } catch (error) {
        console.error('Error ending room:', error);
        toast.error('Failed to end room. Please try again later.');
      }
    } else {
      toast.error('Cannot end room: Room ID or user information is missing.');
    }
  };

  const [blocks, setBlocks] = useState([]);

  const fetchBlocks = async () => {
    if (!roomId) return;

    try {
      const roomRef = doc(db, 'rooms', roomId);

      let tempBlocks = [];

      const blocksRes = await getDocs(
        query(collection(roomRef, 'blocks'), orderBy('timestamp', 'asc'))
      );

      tempBlocks = [
        ...blocksRes.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })),
      ];

      setBlocks(tempBlocks);
    } catch (error) {
      console.error('Error fetching room transactions:', error);
      toast.error('Error fetching room transactions.');
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  return (
    <section className="min-h-screen pt-10 pb-8 px-6">
      <div className="max-w-7xl mx-auto text-white">
        <h1 className="text-2xl font-semibold mb-6">Room Dashboard Overview</h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          <div className="bg-white/5 backdrop-blur-xl rounded-xl p-8 border border-white/10 shadow-2xl shadow-purple-500/10 before:absolute before:inset-0 before:rounded-xl before:bg-gradient-to-br before:from-white/10 before:to-transparent before:opacity-50 before:pointer-events-none">
            <div className="flex items-center gap-3 mb-8 relative z-10">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="text-purple-400"
                    >
                      <circle cx="12" cy="12" r="1" />
                      <path d="M12 1v6m0 6v4" />
                      <path d="M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24" />
                      <path d="M1 12h6m6 0h4" />
                      <path d="M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24" />
                      <path d="M12 23v-6m0-6v-4" />
                      <path d="M19.78 19.78l-4.24-4.24m-5.08-5.08l-4.24-4.24" />
                      <path d="M23 12h-6m-6 0h-4" />
                      <path d="M19.78 4.22l-4.24 4.24m-5.08 5.08l-4.24 4.24" />
                    </svg>
                  </div>
                  <span className="text-white font-semibold">
                    Balance: {userData?.balance && userData.balance.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            <div className="mb-6 relative z-10">
              <label className="text-white/90 text-sm font-medium mb-2 block">
                Room id
              </label>
              <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
                <span className="text-white/80 text-sm truncate flex-1 mr-2">
                  {roomId?.substring(0, 20)}.....
                </span>
                <button
                  onClick={() => {
                    if (roomId && navigator.clipboard) {
                      navigator.clipboard.writeText(roomId);
                      toast.success('Room ID copied!');
                    }
                  }}
                  className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="mb-6 relative z-10">
              <label className="text-white/90 text-sm font-medium mb-2 block">
                Public Key
              </label>
              <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
                <span className="text-white/80 text-sm truncate flex-1 mr-2">
                  {userData?.publicKey?.substring(0, 20)}.....
                </span>
                <button
                  onClick={() => {
                    if (userData?.publicKey && navigator.clipboard) {
                      navigator.clipboard.writeText(userData?.publicKey);
                      toast.success('Public Key copied!');
                    }
                  }}
                  className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="mb-8 relative z-10">
              <label className="text-white/90 text-sm font-medium mb-2 block">
                Private Key
              </label>
              <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
                <span className="text-white/80 text-sm truncate flex-1 mr-2">
                  {userData?.privateKey?.substring(0, 20)}.....
                </span>
                <button
                  onClick={() => {
                    if (userData?.privateKey && navigator.clipboard) {
                      navigator.clipboard.writeText(userData?.privateKey);
                      toast.success(' Private Key copied!');
                    }
                  }}
                  className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="mt-6 relative z-10">
              {createdBy === user.email ? (
                <button
                  onClick={handleEndRoom}
                  type="button"
                  className="w-full px-6 py-3 bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] hover:bg-[#5A31B5] rounded-xl font-medium "
                >
                  End room
                </button>
              ) : (
                <button
                  onClick={handleLeaveRoom}
                  type="button"
                  className="w-full px-6 py-3 bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] hover:bg-[#5A31B5] rounded-xl font-medium"
                >
                  Leave Room
                </button>
              )}
            </div>
          </div>

          <div className="bg-[#2A2F4A] backdrop-blur rounded-xl p-8 border border-[#3A3F5A]">
            <div className="flex items-center gap-3 mb-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="text-blue-400"
                  >
                    <path d="M12 2L2 7V12L12 17L22 12V7L12 2Z" />
                    <path d="M2 17V22L12 27L22 22V17" />
                    <polyline points="12 17 12 27" />
                  </svg>
                </div>
                <span className="text-white font-semibold">Blocks</span>
              </div>
            </div>

            <div className="mb-6">
              <label className="text-white/90 text-sm font-medium mb-2 block">
                Hash
              </label>
              <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
                <span className="text-white text-sm truncate flex-1 mr-2">
                  {blocks && blocks.length > 0
                    ? blocks[blocks.length - 1]?.hash?.substring(0, 20) +
                      '.....'
                    : 'Ah4hd7HJweldfdfdqo.....'}
                </span>

                <button
                  onClick={() => {
                    if (blocks && blocks.length > 0 && navigator.clipboard) {
                      const latestHash = blocks[blocks.length - 1]?.hash;
                      navigator.clipboard.writeText(latestHash);
                      toast.success('Hash copied!');
                    } else {
                      toast.error('No hash to copy');
                    }
                  }}
                  className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="mb-8">
              <label className="text-white/90 text-sm font-medium mb-2 block">
                Previous Block Hash
              </label>
              <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
                <span className="text-white text-sm truncate flex-1 mr-2">
                  {blocks && blocks.length > 0
                    ? (blocks[blocks.length - 1]?.previousBlockHash?.substring(
                        0,
                        20
                      ) || 'genesis') + '.....'
                    : 'Ah4hd7HJweldfdfdqo.....'}
                </span>

                <button
                  onClick={() => {
                    if (!blocks || blocks.length === 0) {
                      toast.error('No previous hash to copy');
                      return;
                    }

                    const prevHash =
                      blocks[blocks.length - 1]?.previousBlockHash;

                    if (prevHash && navigator.clipboard) {
                      navigator.clipboard.writeText(prevHash);
                      toast.success('Previous hash copied!');
                    } else if (!prevHash) {
                      navigator.clipboard.writeText('genesis');
                      toast.success('Copied');
                    } else {
                      toast.error('Clipboard not available');
                    }
                  }}
                  className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Block Stats Grid */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-[#1B1E3E]/60 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                  <span className="text-white/70 text-sm">Timestamp</span>
                </div>
                <p className="text-white font-semibold">
                  {blocks && blocks.length > 0
                    ? new Date(
                        blocks[blocks.length - 1]?.timestamp * 1000
                      ).toLocaleString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      })
                    : '01/01/25/00:00'}
                </p>
              </div>

              <div className="bg-[#1B1E3E]/60 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                  <span className="text-white/70 text-sm">
                    Transaction Count
                  </span>
                </div>
                <p className="text-white font-semibold">
                  {blocks && blocks.length > 0
                    ? blocks[blocks.length - 1]?.transactions?.length || 0
                    : '1245789321'}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-[#1B1E3E]/60 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                  <span className="text-white/70 text-sm">Nonce</span>
                </div>
                <p className="text-white font-semibold">
                  {blocks && blocks.length > 0
                    ? (blocks[blocks.length - 1]?.nonce ?? 0)
                    : '0'}
                </p>
              </div>

              <div className="bg-[#1B1E3E]/60 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                  <span className="text-white/70 text-sm">
                    Transaction Hash
                  </span>
                </div>
                <p className="text-white font-semibold">
                  {blocks &&
                  blocks.length > 0 &&
                  blocks[blocks.length - 1]?.transactions?.length > 0
                    ? '0'
                    : '0'}
                </p>
              </div>

              <div className="bg-[#1B1E3E]/60 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 bg-orange-400 rounded-full"></div>
                  <span className="text-white/70 text-sm">Difficult</span>
                </div>
                <p className="text-white font-semibold">2</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <h4 className="text-white font-semibold mb-3">Blocks</h4>
          <div className="overflow-x-auto">
            <BlockComponent user={user} blocks={blocks} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinedRoom;

function BlockComponent({ blocks }) {
  return (
    <div className="w-full py-4">
      <div className="flex overflow-x-auto gap-6 pb-4 px-2 custom-scrollbar">
        {blocks && blocks.length > 0 ? (
          blocks.map((b, index) => (
            <div key={b.id || index} className="flex gap-4 items-center">
              {/* Block Card */}
              <div className="bg-[#2A2F4A] backdrop-blur rounded-xl p-6 border border-[#3A3F5A] min-w-[350px] shadow-xl">
                <div className="bg-[#1B1E3E]/60 rounded-xl p-3 mb-4 text-center">
                  <h5 className="text-white font-semibold text-lg">
                    Block {index}
                  </h5>
                </div>

                <div className="mb-4">
                  <label className="text-white/80 text-sm font-medium mb-2 block">
                    Hash
                  </label>
                  <div className="bg-[#1B1E3E]/60 rounded-lg p-3">
                    <input
                      className="w-full bg-transparent text-white/90 text-sm outline-none"
                      value={b.hash}
                      disabled
                      readOnly
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="text-white/80 text-sm font-medium mb-2 block">
                    Previous Block Hash
                  </label>
                  <div className="bg-[#1B1E3E]/60 rounded-lg p-3">
                    <input
                      type="text"
                      value={b.previousBlockHash || 'genesis'}
                      className="w-full bg-transparent text-white/90 text-sm outline-none"
                      disabled
                      readOnly
                    />
                  </div>
                </div>

                <div className="bg-[#1B1E3E]/60 rounded-lg p-3 mb-4">
                  <span className="text-white/70 text-sm block mb-1">
                    Timestamp
                  </span>
                  <h6 className="text-white font-semibold">
                    {new Date(b.timestamp * 1000).toLocaleString('en-GB', {
                      day: '2-digit',
                      month: '2-digit',
                      year: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: false,
                    })}
                  </h6>
                </div>

                {/* Nonce and Difficulty Grid */}
                <div className="grid grid-cols-2 gap-3 mb-4">
                  <div className="bg-[#1B1E3E]/60 rounded-lg p-3">
                    <span className="text-white/70 text-sm block mb-1">
                      Nonce
                    </span>
                    <h6 className="text-white font-semibold">{b.nonce ?? 0}</h6>
                  </div>
                  <div className="bg-[#1B1E3E]/60 rounded-lg p-3">
                    <span className="text-white/70 text-sm block mb-1">
                      Difficulty
                    </span>
                    <h6 className="text-white font-semibold">2</h6>
                  </div>
                </div>

                <div className="bg-[#1B1E3E]/60 rounded-lg p-3 mb-4">
                  <span className="text-white/70 text-sm block mb-1">
                    Transaction Count
                  </span>
                  <h6 className="text-white font-semibold">
                    {(b.transactions && b.transactions.length) || 0}
                  </h6>
                </div>

                <div className="bg-[#1B1E3E]/60 rounded-lg p-3">
                  <span className="text-white/70 text-sm block mb-3">
                    Transaction Hashes
                  </span>
                  <div className="h-48 max-h-48 overflow-y-auto space-y-2 pr-2 scrollbar-thin scrollbar-thumb-purple-500 scrollbar-track-transparent">
                    {b.transactions && b.transactions.length > 0 ? (
                      b.transactions.map((t, txIndex) => (
                        <div
                          key={t.id || txIndex}
                          className="flex items-center gap-2 bg-[#1F0F47] rounded-lg p-2"
                        >
                          <span className="text-white/60 text-xs font-semibold min-w-[20px]">
                            {txIndex + 1}.
                          </span>
                          <input
                            type="text"
                            value={t.hash}
                            className="flex-1 bg-transparent text-white/90 text-xs outline-none"
                            disabled
                            readOnly
                          />
                        </div>
                      ))
                    ) : (
                      <p className="text-white/50 text-xs">No transactions</p>
                    )}
                  </div>
                </div>
              </div>

              <img
                src={Arrow}
                className="w-[10rem] pr-5 h-[11rem] z-20"
                alt="connector-arrow"
                aria-hidden="true"
              />
            </div>
          ))
        ) : (
          <div className="w-full text-center py-12">
            <p className="text-white/60 text-lg">No blocks available yet</p>
          </div>
        )}
      </div>
    </div>
  );
}
